var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22M13 2.05C13 2.05 16 6 16 12",
    stroke: "#232735",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 21.95C10.9999 21.95 7.99988 18 7.99988 12C7.99988 5.99999 10.9999 2.04999 10.9999 2.04999M2.62988 15.5H11.9999M2.62988 8.49999H21.3699",
    stroke: "#232735",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8792 17.917C22.3732 18.221 22.3422 18.96 21.8342 19.018L19.2672 19.309L18.1162 21.621C17.8882 22.08 17.1832 21.855 17.0662 21.287L15.8112 15.171C15.7122 14.691 16.1442 14.389 16.5612 14.646L21.8792 17.917Z",
    stroke: "#232735",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4a40961f7d619ca5916f8266d0bc6e13.svg";
export { ForwardRef as ReactComponent };